import App from './App.vue'

import { Auth } from './auth/services/Auth';
import { createApp } from 'vue'
import { router } from './router';
import { store } from './store';
import { loadFonts } from './plugins/webfontloader'
import { VDateInput } from 'vuetify/labs/VDateInput'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { es } from 'vuetify/locale';
import 'vuetify/dist/vuetify.min.css';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

import '@fortawesome/fontawesome-free/css/all.css';
import '@mdi/font/css/materialdesignicons.css';
import './assets/styles/global.css';
import { rules } from './shared/rules';
import moment from 'moment';

import { ClassificationCollection } from './classifications/collections/ClassificationCollection';

import VFullNameComponent from './shared/components/VFullNameComponent.vue';
import VAutocompleteExtended from '@ellevue/autocomplety';
import VTooltip from 'v-tooltip';
import { download } from '@/packages/download/download';
import VDateFieldComponent from './shared/components/VDateFieldComponent.vue';
import { VAutocomplete, VTextField } from 'vuetify/components';

import { period } from './config/reports';
import { API_BASE_URL } from '../config.js';
import { joinUrl } from './shared/joinUrl.js';

const app = createApp(App);

const vuetify = createVuetify({
    icons: {
        defaultSet: 'mdi',
    },
    aliases,
    sets: {
        mdi,
    },
    locale: {
        locale: 'es',
        messages: {
            es,
        },
    },
    components: {
        VDateInput,
        VAutocomplete,
        VTextField
    },
});

app.use(VTooltip);

app.mixin({
    data() {
        return {
            toDelete: null,
            toUpdate: null
        }
    }
});

// Evita que los errores aparezcan en pantalla y solamente se muestran en la consola
app.config.errorHandler = async (error, instance, info) => {
    console.error(error);

    try {
        await fetch(joinUrl(API_BASE_URL, 'frontcatch'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                message: error?.message,
                stack: error?.stack,
                info,
                url: window.location.href
            })
        });
    } catch (error) {
        return;
    }

}

app.config.globalProperties.$auth = () => {
    return Auth;
}

app.config.globalProperties.$classifications = ClassificationCollection.fromJson(localStorage.getItem('classifications') || '[]');

app.config.globalProperties.$rules = rules;

app.config.globalProperties.$download = (path) => {
    download(path);
}

app.component('v-full-name', VFullNameComponent);
app.component('v-autocomplete-extended', VAutocompleteExtended);
app.component('v-date-field', VDateFieldComponent);

app.config.globalProperties.$date = (date, format = null) => {
    if (!date) {
        return null;
    }
    try {
        return moment.utc(date).format(format || 'YYYY-MM-DD');
    } catch (error) {
        return null;
    }
}

app.config.globalProperties.$stringDate = (date) => {
    if (!date) {
        return null;
    }
    try {
        const fecha = new Date(date);
        return new Intl.DateTimeFormat('es-ES', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC'
        }).format(fecha);
    } catch (error) {
        return app.config.globalProperties.$date(date);
    }
}

app.config.globalProperties.$year = (date) => {
    if (!date) {
        return null;
    }
    try {
        return moment.utc(date).format('YYYY');
    } catch (error) {
        return null;
    }
}

app.config.globalProperties.$money = (value) => {
    if (!value) {
        return null;
    }

    if (isNaN(value)) {
        return null;
    }

    let parts = parseFloat(value).toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

app.config.globalProperties.$classification = (classification) => {
    const classifications = ClassificationCollection.fromJson(localStorage.getItem('classifications') || '[]');
    return classifications.whereClassification(classification).first();
}

/**
 * Para obtener el día de hoy
 */
app.config.globalProperties.$today = () => {
    return moment.utc().format('YYYY-MM-DD');
}

app.config.globalProperties.$period = period;

loadFonts();
app.use(FloatingVue);
app.use(vuetify);
app.use(router);
app.use(store);

app.mount('#app');
